// Check if we're in a browser environment - be extra cautious
const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function'

// Storage type enum
export const STORAGE_TYPE = {
  SESSION: 'session',
  LOCAL: 'local'
}

// Max TTL age
export const BROWSER_STORAGE_TTL = {
  TTLNoExpired: -1,
  TTL30Minutes: 1000 * 60 * 30,
  TTL1Hour: 1000 * 60 * 60,
  TTL3Day: 1000 * 60 * 60 * 24 * 3
}

// Helper to get the appropriate storage instance
const getStorageInstance = (storageType = STORAGE_TYPE.LOCAL) => {
  if (!isBrowser) return null
  return storageType === STORAGE_TYPE.LOCAL ? window.localStorage : window.sessionStorage
}

export const writeStoreToBrowserStorage = (store, name, ttl = BROWSER_STORAGE_TTL.TTL30Minutes, storageType = STORAGE_TYPE.LOCAL) => {
  if (!isBrowser) return

  try {
    const expiresAt = ttl === BROWSER_STORAGE_TTL.TTLNoExpired ? -1 : new Date().getTime() + ttl
    const { ttl: storeTtl, ...storeWithoutTtl } = store
    const storeWithTTL = { ...storeWithoutTtl, ttl: expiresAt }
    const storage = getStorageInstance(storageType)

    if (storage) {
      storage.setItem(name, JSON.stringify(storeWithTTL))
    }
  } catch (error) {
    console.error('Error writing to browser storage:', error)
  }
}

export const getFromBrowserStorage = (name, isThrow = true, storageType = STORAGE_TYPE.LOCAL) => {
  if (!isBrowser) return null

  try {
    const storage = getStorageInstance(storageType)
    if (!storage) return null

    const rawStore = storage.getItem(name)
    if (!rawStore) {
      if (isThrow) throw new Error(`Nothing found in ${storageType} storage for ${name}`)
      return null
    }

    let parsed
    try {
      parsed = JSON.parse(rawStore)
    } catch (e) {
      storage.removeItem(name)
      if (isThrow) throw new Error(`Corrupted data for ${name}`)
      return null
    }

    const ttl = parsed['ttl']
    if (ttl !== undefined) {
      const currentTime = new Date().getTime()
      if (ttl === -1 || ttl > currentTime) {
        return parsed
      }
      storage.removeItem(name)
      if (isThrow) {
        throw new Error(`TTL Expired for ${name} in ${storageType} storage, value was ${ttl}. Removing from browser storage`)
      }
    }
    return null
  } catch (error) {
    if (isThrow && typeof error === 'string') {
      throw new Error(error)
    }
    if (isBrowser) {
      console.error('Error getting from browser storage:', error)
    }
    return null
  }
}
